import _symbols from "./symbols.json";

export const SYMBOLS = _symbols as any;
